import MuiPortal from "@mui/material/Portal";

export const Portal = MuiPortal;
